/**
 * Product recommendations debug — open DevTools Console, filter: USIPIC-REC
 * Disable: remove ?usipic_debug=1 from URL and run localStorage.removeItem('usipic_debug')
 */
(function () {
  var TAG = '[USIPIC-REC]';
  var qs = window.location.search || '';
  var enabled =
    qs.indexOf('usipic_debug=1') !== -1 ||
    qs.indexOf('usipic_debug=true') !== -1 ||
    window.localStorage.getItem('usipic_debug') === '1';

  if (!enabled) {
    return;
  }

  if (qs.indexOf('usipic_debug=1') !== -1 || qs.indexOf('usipic_debug=true') !== -1) {
    try {
      window.localStorage.setItem('usipic_debug', '1');
    } catch (e) {}
  }

  function log() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift(TAG);
    console.log.apply(console, args);
  }

  function warn() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift(TAG);
    console.warn.apply(console, args);
  }

  function sectionState(el) {
    if (!el) return null;
    var $section = null;
    if (window.jQuery_T4NT) {
      $section = window.jQuery_T4NT(el).closest('.id_product-recommendations, .t4s-section');
    }
    var sectionEl = $section && $section.length ? $section[0] : el.closest('.id_product-recommendations, .t4s-section');
    return {
      baseurl: el.getAttribute('data-baseurl'),
      type: el.getAttribute('data-type'),
      sid: el.getAttribute('data-sid'),
      productCount: el.querySelectorAll('.t4s-product').length,
      loading: !!el.querySelector('.t4s-loading--bg'),
      innerLen: (el.innerHTML || '').length,
      hidden: sectionEl ? sectionEl.style.display === 'none' || window.getComputedStyle(sectionEl).display === 'none' : null
    };
  }

  function buildFetchUrl(el) {
    if (!el) return '';
    var baseurl = el.getAttribute('data-baseurl') || '';
    var sid = el.getAttribute('data-sid') || '';
    var type = el.getAttribute('data-type');
    var searchPrefix = (window.T4Sroutes && window.T4Sroutes.search_url) || '/search';
    if (type === '3') {
      return (
        baseurl +
        '?section_id=' +
        sid +
        '&product_id=' +
        (el.getAttribute('data-id') || '') +
        '&limit=' +
        (el.getAttribute('data-limit') || '')
      );
    }
    return searchPrefix + baseurl + '&section_id=' + sid;
  }

  log('debug enabled — filter console by USIPIC-REC');

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      if (url && url.indexOf('section_id=') !== -1) {
        log('fetch →', url);
        return nativeFetch.apply(this, arguments).then(function (res) {
          log('fetch ←', url, {
            ok: res.ok,
            status: res.status,
            redirected: res.redirected,
            finalUrl: res.url
          });
          if (res.redirected) {
            warn('redirect detected — theme returns NVT_94 and hides recommendations');
          }
          res.clone().text().then(function (text) {
            log('fetch body', {
              length: text.length,
              hasProduct: text.indexOf('t4s-product') !== -1,
              isNVT94: text === 'NVT_94',
              preview: text.slice(0, 240)
            });
          });
          return res;
        }).catch(function (err) {
          warn('fetch error', url, err);
          throw err;
        });
      }
      return nativeFetch.apply(this, arguments);
    };
  }

  function wrapT4S() {
    if (!window.T4SThemeSP || window.T4SThemeSP.__usipicRecPatched) return !!window.T4SThemeSP;

    var orig = window.T4SThemeSP.getToFetchSection;
    if (typeof orig === 'function') {
      window.T4SThemeSP.getToFetchSection = function (path, type, fullUrl) {
        log('getToFetchSection', { path: path, type: type, fullUrl: fullUrl });
        return orig.apply(this, arguments).then(function (result) {
          log('getToFetchSection result', {
            fullUrl: fullUrl,
            isNVT94: result === 'NVT_94',
            length: typeof result === 'string' ? result.length : null,
            hasProduct: typeof result === 'string' && result.indexOf('t4s-product') !== -1
          });
          return result;
        });
      };
    }

    if (typeof window.T4SThemeSP.productRecommendations === 'function') {
      var origRec = window.T4SThemeSP.productRecommendations;
      window.T4SThemeSP.productRecommendations = function () {
        log('productRecommendations() called');
        return origRec.apply(this, arguments);
      };
    }

    window.T4SThemeSP.__usipicRecPatched = true;
    log('T4SThemeSP hooks installed', {
      root_url: window.T4SThemeSP.root_url,
      search_url: window.T4Sroutes && window.T4Sroutes.search_url
    });
    return true;
  }

  function inspectDom(label) {
    var el = document.getElementById('pr_recommendations');
    if (!el) {
      warn(label, '#pr_recommendations not found');
      return;
    }
    var state = sectionState(el);
    var expectedUrl = buildFetchUrl(el);
    log(label, state);
    log(label, 'expected AJAX URL →', expectedUrl);
    if (state.baseurl && state.baseurl.indexOf('/search') === 0) {
      warn('baseurl starts with /search — JS prepends T4Sroutes.search_url again → broken double /search/search URL. baseurl should start with /?');
    }
  }

  function hookJqHide() {
    if (!window.jQuery_T4NT || window.jQuery_T4NT.fn.__usipicRecHidePatched) return;
    var origHide = window.jQuery_T4NT.fn.hide;
    window.jQuery_T4NT.fn.hide = function () {
      this.each(function () {
        if (
          this.id === 'pr_recommendations' ||
          (this.classList && this.classList.contains('id_product-recommendations'))
        ) {
          warn('jQuery.hide() on recommendations', this.id || this.className, new Error().stack);
        }
      });
      return origHide.apply(this, arguments);
    };
    window.jQuery_T4NT.fn.__usipicRecHidePatched = true;
    log('jQuery hide hook installed');
  }

  function boot() {
    inspectDom('initial');
    hookJqHide();

    var el = document.getElementById('pr_recommendations');
    if (el && typeof MutationObserver !== 'undefined') {
      var obs = new MutationObserver(function () {
        log('DOM changed', sectionState(el));
      });
      obs.observe(el, { childList: true, subtree: true });
    }
  }

  var tries = 0;
  var t4sTimer = setInterval(function () {
    tries++;
    if (wrapT4S() || tries > 120) clearInterval(t4sTimer);
  }, 50);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  [1000, 3000, 6000, 10000].forEach(function (ms) {
    setTimeout(function () {
      inspectDom('t+' + ms + 'ms');
    }, ms);
  });
})();
